import React, { useState, useRef, useEffect } from 'react';
import MultiRangeSlider from './MultiRangeSlider';

const PriceSlider = ({ range, setRange, className = '' }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Handle dropdown toggle
  const toggleDropdown = () => {
    setOpen(!open);
  };

  // Handle outside click to close dropdown
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    // Handle escape key press
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        setOpen(false);
      }
    };

    // Add event listeners if dropdown is open
    if (open) {
      document.addEventListener('mousedown', handleOutsideClick);
      document.addEventListener('keydown', handleEscKey);
    }

    // Clean up event listeners
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [open]);

  return (
    <div className={`${className} relative w-full`} ref={dropdownRef}>
      <div className="relative">
        <div
          onClick={toggleDropdown}
          className="flex !h-full items-center justify-between rounded-lg border border-gray-300 bg-white px-4 py-3 hover:cursor-pointer"
        >
          <div className="flex flex-col gap-1">
            <p className="fredoka text-sm -tracking-[0.28px] text-[#012E33]">Price per lesson: </p>
            <p className="fredoka text-base font-medium capitalize -tracking-[0.16px] text-[#012E33]">
              ${range.minValue} - ${range.maxValue}
            </p>
          </div>
          <img src="/images/icons/chevron-down-outline.svg" alt="" />
        </div>

        {open && (
          <div className="absolute left-0 z-10 w-full rounded-lg bg-white shadow-lg">
            <div className="p-4 pt-8">
              <label
                htmlFor="minValue"
                className="fredoka mb-2 flex items-center justify-center text-xl font-normal text-[#012E33]"
              >
                ${range.minValue} - ${range.maxValue}
              </label>
              <MultiRangeSlider
                min={10}
                max={1000}
                onChange={({ min, max }) => setRange({ minValue: min, maxValue: max })}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PriceSlider;
